import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const DoubleCheckmarkIcon: SVGFC = ({ color = tailwindColors.primary.DEFAULT, ...props }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 4.65795L3.35725 7.38174L9.25 0.572266M13 0.619932L6.571 7.42941L6.25 7.00344"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DoubleCheckmarkIcon
